module.exports = __webpack_public_path__ + "img/cfdm_posterimage_withtext.4a5c08a3.webp";